import { useNavigate } from 'react-router';
import { Button, Card, EmptyState, Skeleton, StatusBadge, Table } from '@/shared/ui';
import { formatClp, formatDateTime } from '@/shared/lib/format';
import { useCreateBatch, useMyBatches } from './api';
import { errorMessage } from '@/shared/api/client';
import { useToast } from '@/app/providers';

/** Solicitudes de fondos (Coordinador): solicitudes múltiples propias + nueva solicitud. */
export function BatchesPage() {
  const q = useMyBatches();
  const create = useCreateBatch();
  const navigate = useNavigate();
  const toast = useToast();
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--sp-5)' }}>
        <h1>Solicitudes de fondos</h1>
        <Button loading={create.isPending} onClick={() => create.mutate({ title: null }, { onSuccess: (b) => navigate(`/solicitudes/${b.id}`), onError: (e) => toast.notify({ title: 'No se pudo crear la solicitud', description: errorMessage(e), kind: 'error' }) })}>Nueva solicitud de fondos</Button>
      </div>
      <Card>
        {q.isPending && <Skeleton height={80} />}
        {q.data && q.data.length === 0 && <EmptyState title="Aún no has creado solicitudes" description="Un envío puede incluir solicitudes para varias personas; Finanzas recibe un correo consolidado por cada envío." />}
        {q.data && q.data.length > 0 && (
          <Table>
            <thead><tr><th>Solicitud</th><th>Título</th><th>Beneficiarios</th><th>Estado</th><th>Creado</th><th>Enviado</th><th style={{ textAlign: 'right' }}>A transferir</th></tr></thead>
            <tbody>{q.data.map((b) => (
              <tr key={b.id} onClick={() => navigate(`/solicitudes/${b.id}`)} style={{ cursor: 'pointer' }}>
                <td className="num">Solicitud múltiple #{b.id}</td><td>{b.title ?? '—'}</td><td className="num">{b.request_count}</td><td><StatusBadge status={b.status} /></td><td>{formatDateTime(b.created_at)}</td><td>{b.submitted_at ? formatDateTime(b.submitted_at) : '—'}</td><td className="num" style={{ textAlign: 'right' }}>{b.status === 'ENVIADO' ? formatClp(b.total_to_transfer_clp) : '—'}</td>
              </tr>
            ))}</tbody>
          </Table>
        )}
      </Card>
    </>
  );
}
